import { resolveImagePath } from '@/utils/imageMap';

export function Hero() {
  const heroImage = resolveImagePath('/images/hero-airport.jpg');

  return (
    <section className="relative h-screen max-h-[600px] min-h-[400px] overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ 
          backgroundImage: `url(${heroImage})`,
        }}
      >
        {/* Optional overlay for better text readability */}
        <div className="absolute inset-0 bg-black bg-opacity-20"></div>
      </div>
      
      {/* Hero Content - positioned to match the original layout */}
      <div className="relative z-10 h-full flex items-center justify-center">
        <div className="text-center text-white">
          {/* This space is intentionally minimal to match the original design 
              which lets the aerial photo speak for itself */}
        </div>
      </div>
    </section>
  );
}